import gql from 'graphql-tag'

export const deleteCartItemMutation = gql`
  mutation removeFromCart($websiteId: ID!, $cartItemId: ID!) {
    removeFromCart(websiteId: $websiteId, cartItemId: $cartItemId) {
      _id
    }
  }
`
